import { render } from "./GuidPanel.vue?vue&type=template&id=0b1ec5a7&ts=true"
import script from "./GuidPanel.vue?vue&type=script&lang=ts"
export * from "./GuidPanel.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Projects\\vdmar\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__